<template>
    <div>
        <policyHeader/>
        <div class="bannerBox">
            <a-carousel :dot-position="bottom">
                <div>
                    <img class="bannerImg" src="../img/shu.jpg" />
                </div>
            </a-carousel>
        </div>
        <div style="width: 100%;background-color: #fff;">
            <div class="breadBox">
                <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png"/>
            当前位置：
          </span>
                    <a-breadcrumb-item>首页</a-breadcrumb-item>
                    <a-breadcrumb-item>双创数据</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
        <div class="box">
            <div class="analysis">
                <chart :option="options2"  style="height: 320px" />
            </div>
            <div class="analysis">
                <chart :option="options3"  style="height: 320px" />
            </div>
        </div>
        <div class="box1">
            <chart :option="options"  style="height: 320px" />
        </div>
        <div class="box1">
            <chart :option="options1"  style="height: 400px" />
        </div>
        <LayoutFooter/>
    </div>

</template>
<script>

import policyHeader from "./policyHeader"
import LayoutFooter from "@/layout/layoutPage/footer/LayoutFooterNew2";
import Chart from "@/components/chart/Chart";
import {ganizationWeb} from "@/api/innovationService";

export default {
  name: 'serviceOrganization',
    components:{Chart, policyHeader,LayoutFooter},
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
        options:[],
        options1:[],
        options2:[],
        options3:[],

    }
  },
    mounted() {
      this.getAnalysis()
      this.getBase()
      this.getProperty()
      this.getInnovationData()
    },
    methods:{
      getAnalysis(){
          this.getAction({
              url:ganizationWeb.analysis
          }).then(res=>{
              this.options = {
                  title: {
                      text: '企业分析',
                      left: 'left',
                      top: '5%',

                  },
                  tooltip: {
                      trigger: 'item'
                  },
                  legend: {
                      top: '5%',
                      left: 'right'
                  },
                  series: [
                      {
                          name: '明星企业',
                          type: 'pie',
                          radius: ['40%', '70%'],
                          avoidLabelOverlap: false,
                          itemStyle: {
                              borderRadius: 10,
                              borderColor: '#fff',
                              borderWidth: 2
                          },
                          label: {
                              show: false,
                              position: 'center'
                          },
                          emphasis: {
                              label: {
                                  show: true,
                                  fontSize: 20,
                                  fontWeight: 'bold'
                              }
                          },
                          labelLine: {
                              show: false
                          },
                          data: res
                      }
                  ]
              }
          })
      },
      getInnovationData(){
          this.options3 = {
              title: {
                  text: '双创数据',
                  top: '5%'
              },
            tooltip: {
                trigger: 'item'
            },
              legend: {
                  top: 'right'
              },
              toolbox: {
                  show: true,
                  feature: {
                      mark: { show: true },
                  }
              },
              series: [
                  {
                      name: '双创数据',
                      type: 'pie',
                      radius: [40, 90],
                      center: ['50%', '50%'],
                      roseType: 'area',
                      itemStyle: {
                          borderRadius: 8
                      },
                      data: [
                          { value: 40, name: '成果项目数量' },
                          { value: 38, name: '金融产品数量' },
                          { value: 32, name: '提供岗位数量' },
                      ]
                  }
              ]
          }
        },
        getBase(){
            this.getAction({
                url:ganizationWeb.baseCharts
            }).then(res=>{
                console.log(res,'res')
                let baseName = [];
                let baseValue = [];
                res.forEach(item=>{
                    if(item.group==1){
                        baseName.push('('+item.name+')国家级科技企业孵化器')
                    }else if(item.group==2){
                        baseName.push('('+item.name+')国家备案众创空间')
                    }else if(item.group==3){
                        baseName.push('('+item.name+')省级双创基地')
                    }
                    baseValue.push(item.value)
                })
                console.log(baseName,'arr')
                this.options1 = {
                    title: {
                        text: '双创基地分析',
                        top:"5%"
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {},
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        axisLine: {
                        show:true,
                        },
                        boundaryGap: [0, 0.01]
                    },
                    yAxis: {
                        type: 'category',
                        data: baseName
                    },
                    series: [
                        {
                            name: '双创基地分析',
                            type: 'bar',
                            data: baseValue
                        }
                    ]
                }
            })
        },
        getProperty(){
          this.getAction({
              url:ganizationWeb.propertyCharts
          }).then(res=>{
              let propertyName = []
              let propertyValue = []
              res.forEach(item=>{
                  propertyName.push(item.name)
                  propertyValue.push(item.value)
              })
              this.options2 = {
                  title: {
                      text: '知识产权分析',
                      top:"5%"
                  },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                  xAxis: {
                      type: 'category',
                      data: propertyName
                  },
                  yAxis: {
                      type: 'value'
                  },
                  series: [
                      {
                          data: propertyValue,
                          type: 'bar',
                          showBackground: true,
                          barWidth:"40%",
                          // backgroundStyle: {
                          //     color: 'rgba(168, 222, 246)'
                          // }
                          itemStyle: {
                              borderRadius: [3, 3, 0, 0], // 柱体宽度
                              color: '#a8def5' // 未选中柱颜色
                          },
                          emphasis: {
                              itemStyle: {
                                  color: '#6ec8ef' // 选中柱颜色
                              }
                          }
                      }
                  ]
              }
          })

        },
        
    }
}
</script>
<style scoped lang="less">
.bannerBox {
    position: relative;
    width: 100%;
    //margin-bottom: 20px;

    .bannerImg {
        width: 100%;
        height: 100%;
    }

    .showMoreButton {
        position: absolute;
        top: 55%;
        left: 21.5%;
        width: 170px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        background-color: #0048c4;
        color: #fff;
        cursor: pointer;
    }
}
.breadBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0;
}
.tabBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0 20px 0;
}
.box{
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
}

.analysis{
    flex: 1;
    height: 320px;
    border: 1px solid #ffffff;
    &:nth-child(odd){
        margin-right: 30px;
    }
    &:hover{
        border: 1px solid #f0f2f5;
        box-shadow: 1px 1px 10px 1px #b0fcff;
    }
}
.box1{
    border: 1px solid #ffffff;
    &:hover{
        border: 1px solid #f0f2f5;
        box-shadow: 1px 1px 10px 1px #b0fcff;
    }
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
}

</style>
